module.exports = __webpack_public_path__ + "img/novendselected.9d40c64f.svg";